import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

/** Minimal shell for the Ardel journey, whose screens render their own header/footer. */
@Component({
  selector: 'app-journey-layout',
  standalone: true,
  imports: [RouterModule],
  template: '<router-outlet></router-outlet>',
})
export class JourneyLayoutComponent {}
